import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

export default ({
  input,
  label,
  optionsToRender,
  multi,
  meta: { touched, error, warning },
  labelClass,
  clearable,
  disabled
}) => (
  <div className={`form-group ${(error && "state-error") || ""}`}>
    <label className={`control-label ${labelClass || ""}`}>{label}</label>
    <Select
      value={input.value}
      onChange={input.onChange}
      onBlur={() => input.onBlur(input.value)}
      options={optionsToRender}
      placeholder={label}
      simpleValue
      multi={multi}
      clearable={!!clearable}
      noResultsText={"Список пуст"}
      disabled={disabled}
    />
    {touched &&
      ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
);

